import { useState } from 'react';
import { useReduxState } from 'hooks';
import { CoursesViewAvailable } from 'components/courses';

import type { HomeModuleProps } from './Home';

const HomeCoursesNew = ({
  defaultTitle,
  limit,
  module,
  spacing
}: HomeModuleProps) => {
  const { language } = useReduxState();

  const [noData, setNoData] = useState(false);

  if (!module) return null;

  const queryParams = `&publishSince=${
    module['data']?.monthsAfterPublish || 0
  }`;

  const description =
    module.descriptionTranslations?.[language] || module.description;

  const title =
    module.titleTranslations?.[language] || module.title || defaultTitle;

  return (
    <div {...(!noData ? { style: { marginTop: spacing } } : {})}>
      <CoursesViewAvailable
        defaultSort="published"
        description={description}
        hideIfNoData={true}
        isHomeView={true}
        limitPerPage={module.limit || limit}
        onNoData={(hasNoData) => setNoData(!hasNoData)}
        queryParams={queryParams}
        showAllLinkHref={`/courses?type=available${queryParams}&sortBy=published`}
        title={title}
        titleShowCount={false}
      />
    </div>
  );
};

export default HomeCoursesNew;
